import { accountServices } from '@/services'
import { store } from '@/store'
import { employeesApi } from '@/store/services'
import { defer, redirect } from 'react-router-dom'
import { list } from '../utils'

export const EmployeeListLoader = (params) => {
  const { url } = params.request
  const searchParams = new URL(url).searchParams.toString()
  if (!searchParams) {
    const defaultSearchParams = new URLSearchParams([
      ['page', 1],
      ['per_page', 10],
      ['order[field]', 'created_at'],
      ['order[sort]', 'desc']
    ])
    return redirect(list('employees') + `?${defaultSearchParams}`)
  }

  const employees = store
    .dispatch(employeesApi.endpoints.getEmployees.initiate(`?${searchParams}`))
    .unwrap()

  return defer({ employees })
}

export const EmployeeLoaders = Object.freeze({
  create: async () => {
    const countries = await accountServices.getCountries();
    return { 
      data: {
        countries: countries.data || []
      }
    };
  },

  edit: async ({ params: { id } }) => {
    try {
      const [countriesResponse, employeeResponse] = await Promise.all([
        accountServices.getCountries(),
        store.dispatch(employeesApi.endpoints.getEmployee.initiate({ id })).unwrap()
      ]);
      
      return {
        countriesData: countriesResponse.data,
        employeeData: employeeResponse, // Nota: employeeResponse ya contiene { employee: ... }
        error: null,
        loading: false
      };
    } catch (error) {
      return {
        countriesData: null,
        employeeData: null,
        error: error.message,
        loading: false
      };
    }
  },  

  attachments: ({ params: { id } }) => {
    return Promise.all([
      store
        .dispatch(
          employeesApi.endpoints.getEmployee.initiate({
            id
          })
        )
        .unwrap()
    ])
  },

  countries: async () => {
    try {
      const response = await accountServices.getCountries();
      return response?.data?.countries || [];
    } catch (error) {
      console.error("Error loading countries:", error);
      return [];
    }
  },
})
